import { render, staticRenderFns } from "./TotalPanel.vue?vue&type=template&id=18ded330&scoped=true&"
import script from "./TotalPanel.vue?vue&type=script&lang=js&"
export * from "./TotalPanel.vue?vue&type=script&lang=js&"
import style0 from "./TotalPanel.vue?vue&type=style&index=0&id=18ded330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ded330",
  null
  
)

export default component.exports